import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Diamond: React.FC<SVGProps<SVGSVGElement>> = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.29289 4.70711C9.68342 4.31658 10.3166 4.31658 10.7071 4.70711L15.2929 9.29292C15.6834 9.68344 15.6834 10.3166 15.2929 10.7071L10.7071 15.2929C10.3166 15.6835 9.68342 15.6835 9.29289 15.2929L4.70708 10.7071C4.31656 10.3166 4.31656 9.68344 4.70708 9.29292L9.29289 4.70711Z"
        fill="#35C08E"
      />
    </svg>
  )
}

Diamond.displayName = 'Diamond'

export default withIcon(Diamond)
